import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-ink text-cream relative overflow-hidden mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-baseline gap-2">
              <span className="font-serif-display text-3xl font-bold text-cream">Sip</span>
              <span className="font-serif-editor italic text-3xl text-pink-brand">Alchemy</span>
            </div>
            <p className="mt-4 text-cream/70 max-w-md font-body leading-relaxed">
              The Indian modernist's guide to spirits, mixology and the culture around them. Learn, discover, sip — always responsibly.
            </p>
            <a
              href="https://instagram.com/sip_alchemy_"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-6 chip chip-cream"
              data-testid="footer-instagram"
            >
              <Instagram size={14} /> @sip_alchemy_
            </a>
          </div>

          <div>
            <p className="eyebrow mb-4">Explore</p>
            <ul className="space-y-2 font-body text-cream/80">
              <li><Link to="/drink-finder" className="hover:text-pink-brand">Drink Finder</Link></li>
              <li><Link to="/cocktails" className="hover:text-pink-brand">Cocktails</Link></li>
              <li><Link to="/learn" className="hover:text-pink-brand">Learn</Link></li>
              <li><Link to="/about" className="hover:text-pink-brand">About</Link></li>
            </ul>
          </div>

          <div>
            <p className="eyebrow mb-4">Work With Us</p>
            <ul className="space-y-2 font-body text-cream/80">
              <li><Link to="/contact" className="hover:text-pink-brand">Brand Collabs</Link></li>
              <li><a href="mailto:sipalchemy.collabs@gmail.com" className="flex items-center gap-2 hover:text-pink-brand break-all" data-testid="footer-email"><Mail size={14} className="flex-shrink-0" /> sipalchemy.collabs@gmail.com</a></li>
            </ul>
          </div>
        </div>

        <div className="hr-rule-cream my-8" />

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-cream/60">
          <p>© {new Date().getFullYear()} Sip Alchemy. All rights reserved.</p>
          <p className="uppercase tracking-widest text-pink-brand font-semibold text-[10px] sm:text-xs">Drink Responsibly · Legal drinking age varies by state</p>
        </div>
      </div>
    </footer>
  );
}
